import { gql } from '@apollo/client';

export const DELETE_USER = gql`
  mutation DeleteUser($userId: ID!) {
    deleteUser(userId: $userId) {
      void
    }
  }
`;

export const UPDATE_USER_STATUS = gql`
  mutation UpdateUserStatus($userId: ID!, $status: UserStatusTypeEnum!) {
    updateUserStatus(userId: $userId, status: $status) {
      user {
        id
        status
      }
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query User($userId: ID!) {
    user(userId: $userId) {
      id
      status
      tester
      guest
      admin
      profile {
        id
        email
        firstName
        lastName
        gender
        birthdate
        country
        smartphone
        computer
        tablet
        state
        paypalAccount
        raceEthnicHeritage
        annualHouseholdIncome
        workStatus
        languages
        educationLevel
        jobCategories{
          id
          name
        }
        currentPosition{
          title
          seniority
          company{
            size
            industry
          }
        }
      }
    }
  }
`;
